<template>
  <div class="sf-view">
    <loading v-if="renderLoading"></loading>

    <div class="sf-toolbar">
      <p class="sf-toolbar__hint">سفته‌های شما بر اساس مرحله، در سه گروه نمایش داده می‌شوند.</p>
      <button type="button" class="sf-btn sf-btn--primary" @click="NewSafte">
        <i class="fas fa-plus"></i>
        ثبت سفته جدید
      </button>
    </div>

    <section class="sf-group">
      <header class="sf-group__header">
        <span class="sf-group__dot sf-group__dot--warning"></span>
        <h5 class="sf-group__title">پیش‌نویس سفته</h5>
        <span class="sf-count">{{ SafteUnPayed.length }}</span>
      </header>
      <div v-if="SafteUnPayed.length == 0" class="sf-empty">پیش‌نویسی وجود ندارد</div>
      <ul v-else class="sf-list">
        <li v-for="(item, index) in SafteUnPayed" :key="index" class="sf-item">
          <div class="sf-item__metas">
            <div class="sf-meta">
              <span class="sf-meta__label">مبلغ</span>
              <span class="sf-meta__value">{{ $Comma3ragham(item.amount) + ' ' + $GetVahedPool() }}</span>
            </div>
            <div class="sf-meta">
              <span class="sf-meta__label">تاریخ</span>
              <span class="sf-meta__value">{{ item.dateTimeInsert.substring(0, 10) }}</span>
            </div>
            <div class="sf-meta">
              <span class="sf-meta__label">توضیحات</span>
              <span class="sf-meta__value">{{ item.description.substring(0, 20) }}</span>
            </div>
          </div>
          <div class="sf-item__actions">
            <a
              class="sf-btn sf-btn--soft sf-btn--sm"
              download="Safte.PDF"
              target="_blank"
              :href="'data:application/pdf;base64,' + item.unsigned_data"
            >
              <i class="fas fa-eye"></i>
              مشاهده سفته
            </a>
            <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" @click="paySafte(item)">
              پرداخت هزینه سفته
            </button>
            <button type="button" class="sf-btn sf-btn--danger sf-btn--sm" @click="deletePishnevis(item)">
              <i class="fas fa-trash-alt"></i>
              حذف
            </button>
          </div>
        </li>
      </ul>
    </section>

    <section class="sf-group">
      <header class="sf-group__header">
        <span class="sf-group__dot"></span>
        <h5 class="sf-group__title">سفته‌های امضا نشده</h5>
        <span class="sf-count">{{ SaftePayed.length }}</span>
      </header>
      <div v-if="SaftePayed.length == 0" class="sf-empty">سفته امضا نشده‌ای وجود ندارد</div>
      <ul v-else class="sf-list">
        <li v-for="(item, index) in SaftePayed" :key="index" class="sf-item">
          <div class="sf-item__metas">
            <div class="sf-meta">
              <span class="sf-meta__label">نام متعهد</span>
              <span class="sf-meta__value">{{ item.moteahedNameFamily }}</span>
            </div>
            <div class="sf-meta">
              <span class="sf-meta__label">تاریخ</span>
              <span class="sf-meta__value">{{ item.dateTimeInsert.substring(0, 10) }}</span>
            </div>
          </div>
          <div class="sf-item__actions">
            <a
              class="sf-btn sf-btn--soft sf-btn--sm"
              download="Safte.PDF"
              target="_blank"
              :href="'data:application/pdf;base64,' + item.unsigned_data"
            >
              <i class="fas fa-eye"></i>
              مشاهده سفته
            </a>
            <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" @click="Signs(item)">
              امضای سفته
            </button>
          </div>
        </li>
      </ul>
    </section>

    <section class="sf-group">
      <header class="sf-group__header">
        <span class="sf-group__dot sf-group__dot--success"></span>
        <h5 class="sf-group__title">سفته‌های نهایی شده</h5>
        <span class="sf-count">{{ SafteFinall.length }}</span>
      </header>
      <div v-if="SafteFinall.length == 0" class="sf-empty">سفته نهایی شده‌ای وجود ندارد</div>
      <ul v-else class="sf-list">
        <li v-for="(item, index) in SafteFinall" :key="index" class="sf-item">
          <div class="sf-item__metas">
            <div class="sf-meta">
              <span class="sf-meta__label">نام متعهد</span>
              <span class="sf-meta__value">{{ item.moteahedNameFamily }}</span>
            </div>
            <div class="sf-meta">
              <span class="sf-meta__label">تاریخ</span>
              <span class="sf-meta__value">{{ item.dateTimeInsert.substring(0, 10) }}</span>
            </div>
          </div>
          <div class="sf-item__actions">
            <button
              v-if="item.FinallData == null"
              type="button"
              class="sf-btn sf-btn--primary sf-btn--sm"
              @click="SafteFinally(item)"
            >
              استعلام نهایی سفته
            </button>
            <a
              v-else
              class="sf-btn sf-btn--primary sf-btn--sm"
              download="Safte.PDF"
              target="_blank"
              :href="'data:application/pdf;base64,' + item.FinallData"
            >
              <i class="fas fa-download"></i>
              دانلود سفته
            </a>
          </div>
        </li>
      </ul>
    </section>
  </div>
</template><script>
import Loading from '../../Tools/NetPa/Loading.vue'

export default {
  components: { Loading },
  props: ['Sign'],
  data() {
    return {
      renderLoading: false,
      SafteUnPayed: [],
      SaftePayed: [],
      SafteFinall: [],
    }
  },
  methods: {
    GetList() {
      var GetParams = { method: 'POST', action: 'ElectronicSafte/GetSafteList', arryfildValue: {} }
      this.$PostData_netpatoken(GetParams).then((result) => {
        // console.log(result)
        this.SafteUnPayed = result.filter((x) => !x.paymentSuccess)
        this.SaftePayed = result.filter((x) => x.paymentSuccess == true && x.isSubmited == false)
        this.SafteFinall = result.filter((x) => x.paymentSuccess == true && x.isSubmited == true)
      })
    },
    paySafte(safte) {
      var DataAxiosAdd = {
        BnpInfo: {
          CustCode: this.$session.get('CustCode'),
          BnpToken: this.$session.get('TokenNetPa'),
          LoginCodeMelli: this.$session.get('UserInfoNetPa').codeMeli,
        },
        callback_url: window.location.host + '/VerifySafte',
        request_id: safte.request_id,
      }
      var AxiosData = { method: 'POST', action: 'ElectronicSafte/LinkPay', arryfildValue: DataAxiosAdd }
      this.$PostData_netpatoken(AxiosData).then((result) => {
        if (result.status == 'success') {
          window, (location = result.data.payment_gateway_link)
        } else {
          this.$mySweetDefault('مشکلی بوجود آمده است', result.data.errors[0].message, 'error', 1500)
        }
      })
    },
    NewSafte() {
      this.$emit('NewSafte', null)
    },
    Signs(safte) {
      this.$emit('SignF', safte)
    },
    SafteFinally(safte) {
      this.renderLoading = true
      var DataAxios = {
        method: 'POST',
        action: 'ElectronicSafte/SafteFinally',
        arryfildValue: {
          BnpInfo: {
            CustCode: this.$session.get('CustCode'),
            BnpToken: this.$session.get('TokenNetPa'),
            LoginCodeMelli: this.$session.get('UserInfoNetPa').codeMeli,
          },
          request_id: safte.request_id,
          signed_pdf: safte.signed_pdf,
        },
      }

      this.$PostData_netpatoken(DataAxios)
        .then((result) => {
          this.GetList()
        })
        .finally(() => {
          this.renderLoading = false
        })
    },
    deletePishnevis(safte) {
      this.renderLoading = true
      var DataAxios = {
        method: 'POST',
        action: 'ElectronicSafte/DeletePishnevis',
        arryfildValue: {
          BnpInfo: {
            CustCode: this.$session.get('CustCode'),
            BnpToken: this.$session.get('TokenNetPa'),
            LoginCodeMelli: this.$session.get('UserInfoNetPa').codeMeli,
          },
          request_id: safte.request_id,
          signed_pdf: safte.signed_pdf,
        },
      }

      this.$PostData_netpatoken(DataAxios)
        .then((result) => {
          if ((result.status = 'success')) {
            this.$mySweetDefault(' عملیات موفق!', 'پیش نویس سفته با موفقیت حذف شد.', 'success', 1500)

            this.GetList()
          } else {
            this.$mySweetDefault(' عملیات ناموفق!', 'مشکلی در حذف سفته بوجود آمده است.', 'error', 1500)
          }
        })
        .finally(() => {
          this.renderLoading = false
        })
    },
  },
  created() {
    
    this.GetList()
  },
}
</script>
